import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useQueryParam, StringParam } from 'use-query-params';

import { loadFormDefinition } from '@redux/modules/formGeneration';
import { setCurrentAgent } from '@redux/modules/agent';
import { getAgentSelected } from '@redux/selectors/AgentSelector';

import CreateAgentForm from '@components/form/forms/CreateAgentForm';

const EditAgentPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currAgent = useSelector(getAgentSelected);
  const [urlParam, setUrlParam] = useQueryParam('UniqueID', StringParam);

  const jsonBody = {
    action: 'select',
    where: {
      clause: [],
    },
  };

  const alertUser = e => {
    e.preventDefault(); // cancel the event
    e.returnValue = ''; // chrome requires return value to be set
  };

  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);

    if (urlParam) {
      jsonBody.where.clause.push({ name: 'UniqueID', value: urlParam });
      dispatch(loadFormDefinition('edit', 'agent', null, urlParam, 'agentACL'));
      dispatch(setCurrentAgent(jsonBody));
    }

    return () => window.removeEventListener('beforeunload', alertUser);
  }, []);

  /*
    This has to be done using location. Currently, when the user loads a form, it redirects the user to the
      create/edit page. When this happens, it clears out the path and search values in the location object.
      We can't memo the location and use that as a comparison, because technically the locations will be
      the same on the reload, so we can't reset the search value in the location object.
  */
  useEffect(() => {
    if (location?.search === '') {
      if (currAgent) {
        setUrlParam(currAgent?.UniqueID);
      }
    }
  }, [location]);

  useEffect(() => {
    if (currAgent) {
      if (location?.search === '' || location?.search !== currAgent?.UniqueID) {
        setUrlParam(currAgent?.UniqueID);
      }
    }
  }, [currAgent]);

  return (
    <>
      <div className="subheader">
        <h1 className="subheader-title">
          <i className="subheader-icon fal fa-ballot mr-2" />
          Edit Agent
        </h1>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <CreateAgentForm />
        </div>
      </div>
    </>
  );
};

export default EditAgentPage;
